import { gql } from "@apollo/client";

export const ADD_KAVA_PREMIUM_MEMBER_LIMIT = gql`
  mutation AddKavaPremiumMemberLimit(
    $premiumMemberId: ID!
    $participationLowerLimit: Float!
  ) {
    addKavaPremiumMemberLimit(
      premium_member_id: $premiumMemberId
      participation_lower_limit: $participationLowerLimit
    )
  }
`;

export const UPDATE_KAVA_PREMIUM_MEMBER_LIMIT = gql`
  mutation UpdateKavaPremiumMemberLimit(
    $premiumMemberLimitId: ID!
    $participationLowerLimit: Float!
  ) {
    updateKavaPremiumMemberLimit(
      premium_member_limit_id: $premiumMemberLimitId
      participation_lower_limit: $participationLowerLimit
    )
  }
`;

export const DELETE_KAVA_PREMIUM_MEMBER_LIMIT = gql`
  mutation DeleteKavaPremiumMemberLimit($premiumMemberLimitId: ID!) {
    deleteKavaPremiumMemberLimit(premium_member_limit_id: $premiumMemberLimitId)
  }
`;
